


























































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import AlpacaBtn from '@/components/AlpacaBtn.vue';
import AInfo from '@/components/AInfo.vue';
import BigNumber from 'bignumber.js';
import { 
  getCAOEarned, 
  getDeposit, 
  getTotalDepositUSD,
  getAPR,
  getTokenRemaining,
} from '@/utils/bank';
import { 
  balanceOf,
  allowance,
  approve
} from '@/contract/token';
import {
  deposit,
  claim,
  withdraw,
  getTotalDeposit,
  poolDepositInfo,
  userDepositInfo,
} from '@/contract/soloBank';
import { EventBus } from "@/utils/EventBus";

const token = {
  0: {name: 'MDX', sub: 'stake MDX earn USDT', icon: 'MDX.webp'},
  1: {name: 'HMDX', sub: 'stake HMDX earn USDT', icon: 'HMDX.webp'},
  2: {name: 'BNB', sub: 'stake BNB earn USDT', icon: 'BNB.jpeg'},
  3: {name: 'BTCB', sub: 'stake BTCB earn USDT', icon: 'BTCB.webp'},
  4: {name: 'ETH', sub: 'stake ETH earn USDT', icon: 'ETH.webp'},
  6: {name: 'BUSD', sub: 'stake BUSD earn USDT', icon: 'BUSD.png'},
  7: {name: 'USDT', sub: 'stake USDT earn USDT', icon: 'USDT.webp'},
}

@Component({
  components: {
    AlpacaBtn,
    AInfo,
  },
})
export default class BankCard extends Vue {
  @Prop({
    required: true,
    type: Number,
  })
  public pid!: number;

  public totalDeposit = new BigNumber(0);
  public totalAPY: number = 0;
  public earned = new BigNumber(0);
  public deposit = new BigNumber(0);
  public balance = new BigNumber(0);
  public allowance = new BigNumber(0);
  public remaining = new BigNumber(0);

  public showWithdraw: boolean = false;
  public depositNum: string = "0";
  public withdrawNum: string = "0";
  public approveLoading: boolean = false;

  get account() {
    return this.$store.getters.getAccount;
  }

  get token() {
    return token;
  }

  get showApprove() {
    return (this.allowance.isEqualTo(0) || this.allowance.isLessThan(new BigNumber(this.depositNum))) && this.pid !== 2;
  }

  get canClaim() {
    return this.deposit.isGreaterThan(0);
  }

  get isOtherToken() {
    return this.pid !== 8 && this.pid !== 9;
  }

  public async mounted() {
    // this.totalDeposit = this.pid === 8 ? await getTotalDepositUSD(this.pid) : new BigNumber(await getTotalDeposit(this.pid));
    // this.totalAPR = await getAPR(this.pid);
    // this.caoEarned = await getCAOEarned(this.pid, this.account);
    // this.deposit = await getDeposit(this.pid, this.account);
    this.balance = await balanceOf(this.pid, this.account);
    this.getPoolDepositInfo();
    this.getUserDepositInfo();
    this.allowance = await allowance(this.pid, this.account);
    // this.remaining = await getTokenRemaining(this.pid, this.account);
    EventBus.$on(`token-approve-status-${this.pid}`, this.onApproveStatus);
  }

  public beforeDestroy() {
    EventBus.$off(`token-approve-status-${this.pid}`, this.onApproveStatus);
  }

  public async onApproveStatus(status: "completed" | "error") {
    if (status === "completed") {
      this.allowance = await allowance(this.pid, this.account);
      this.approveLoading = false;
    }
    if (status === "error") {
      this.approveLoading = false;
    }
  }

  public async getPoolDepositInfo() {
    const res = await poolDepositInfo(this.pid);
    if (res) {
      this.totalAPY = Number(res.apy) / 100;
      this.remaining = new BigNumber(window.web3.utils.fromWei(res.remaining, 'ether'));
      this.totalDeposit = new BigNumber(window.web3.utils.fromWei(res.totalDeposit, 'ether'));
    }
  }

  public async getUserDepositInfo() {
    const res = await userDepositInfo(this.pid, this.account);
    if (res) {
      this.earned = new BigNumber(window.web3.utils.fromWei(res.earned, 'ether'));
      this.deposit = new BigNumber(window.web3.utils.fromWei(res.deposit, 'ether'));
    }
  }

  public handleApprove() {
    this.approveLoading = true;
    approve(this.pid, this.account);
  }

  public clickWithdraw() {
    this.showWithdraw = true;
  }

  public handleClaim() {
    claim(this.pid, this.account);
  }

  public handleDeposit() {
    deposit(this.pid, new BigNumber(this.depositNum), this.account);
  }

  public handleWithdraw() {
    withdraw(this.pid, new BigNumber(this.withdrawNum), this.account);
  }

  public depositChange() {
    if (this.depositNum === "") {
      return;
    } else if (new BigNumber(this.depositNum).isLessThan(0)) {
      this.depositNum = "0";
    } else if (
      new BigNumber(this.depositNum).isGreaterThan(this.balance)
    ) {
      this.depositNum = this.balance.toString();
    }
  }

  public withdrawChange() {
    if (this.withdrawNum === "") {
      return;
    } else if (new BigNumber(this.withdrawNum).isLessThan(0)) {
      this.withdrawNum = "0";
    } else if (
      new BigNumber(this.withdrawNum).isGreaterThan(this.deposit)
    ) {
      this.withdrawNum = this.deposit.toString();
    }
  }

  public maxDeposit() {
    this.depositNum = this.balance.toString();
  }

  public maxWithdraw() {
    this.withdrawNum = this.deposit.toString();
  }

  @Watch('totalAPY', {immediate: true})
  public onTotalAPY(val: any, oldVal: any) {
    if (this.pid === 0) {
      console.log(oldVal)
      console.log(val)
    }
  }

}
